import { z } from 'zod';
import { parseJSON } from 'date-fns';

export const questionTypeSchema = z.enum(['MCSA', 'MCMA', 'SFA']);
export const optionsTypeSchema = z.enum(['TEXT', 'EMOJI']);

export const studentSchema = z.object({
  id: z.string(),
  firstName: z.string(),
  lastName: z.string(),
});

export const resultSchema = z.object({
  correct: z.array(studentSchema),
  incorrect: z.array(studentSchema),
  partiallyCorrect: z.array(studentSchema).optional(),
});

export const responseSchema = z.object({
  student: studentSchema,
  response: z.string().optional().nullable(),
  selectedOptions: z.array(z.string()).optional().nullable(),
  date: z
    .string()
    .optional()
    .nullable()
    .transform<Date | undefined>((d) => (d ? parseJSON(d) : undefined)),
});

export const questionSchema = z.object({
  question: z.string(),
  questionId: z.string(),
  type: questionTypeSchema,
  options: z.array(z.string()).optional().nullable(),
  optionsType: optionsTypeSchema.optional().nullable().default('TEXT'),
  results: resultSchema.optional(),
  correctOptions: z.array(z.string()).optional().nullable(),
  selectedOptions: z.array(z.string()).optional(),
  responses: z.array(responseSchema).optional().nullable(),
  response: z.string().optional().nullable(),
  avgCorrect: z.number().optional(),
  standards: z.array(z.string()).optional(),
  skills: z.array(z.string()).optional(),
  result: z
    .enum(['CORRECT', 'INCORRECT', 'PARTIALLY_CORRECT'])
    .optional()
    .nullable(),
});

export type MetricsActivityQuestion = z.infer<typeof questionSchema>;
